import React from 'react';
import { GetAppSettings, GoFormzServices } from '../AppSettings';
import Loader from '../components/loader';
import { useApimPost } from '../hooks/useApi';
import { videoQuery } from './helpers';
import { VideoItem as VideoItemType, VideoCategory, VideoResponse } from './successlauncher-types';

export interface VideoProps {
  category: VideoCategory;
}

export default function VideoPage(props: VideoProps) {
  const { category } = props;
  const { CmsEnvironment } = GetAppSettings();
  const query = videoQuery(category);
  const [videoReponse, isLoading] = useApimPost<VideoResponse>(GoFormzServices.CmsService, `/cms/graphql`, query);

  return (
    <div className="videos">
      {isLoading ? (
        <Loader isLoading />
      ) : (
        videoReponse.data.SL_Video.filter((x) => x.Environment?.some((env) => env === CmsEnvironment)).map((x, i) => (
          <VideoItem key={i} videoItem={x} position={x.Position} />
        ))
      )}
    </div>
  );
}

interface VideoItemProps {
  videoItem: VideoItemType;
  position: number;
}

function VideoItem(props: VideoItemProps) {
  const { videoItem } = props;

  return (
    <div className="video-item">
      <div className="video-header">{videoItem.Title}</div>
      <div className="video-body">{videoItem.Body}</div>
      <div className="video">
        <iframe
          src={videoItem.URL}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="video-iframe"
          width="400px"
          height="230px"
        ></iframe>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>
    </div>
  );
}
